import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/shop/setting";

export const setting = {
    // ...example,
    get(data){
        return axios.get(`${url}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
}
